import { SmartComponent } from "smart-component-js";

class OverlayComponent extends SmartComponent {
  constructor(element, parentComponent, params) {
    super(element, parentComponent, params);
    this.element = element;
    this.init();
  }

  init() {
    this.setupOverlay();
    this.setupEventListeners();
  }

  setupOverlay() {
    this.hideOverlay();
  }

  setupEventListeners() {
    this.element.addEventListener("click", (e) => {
      if (e.target === this.element) {
        this.hideOverlay();
        const hideMenuEvent = new CustomEvent("hide-menu");
        document.dispatchEvent(hideMenuEvent);
      }
    });

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && this.element.classList.contains("is-active")) {
        this.hideOverlay();
        const hideMenuEvent = new CustomEvent("hide-menu");
        document.dispatchEvent(hideMenuEvent);
      }
    });

    document.addEventListener("show-overlay", () => {
      this.showOverlay();
    });

    document.addEventListener("hide-overlay", () => {
      this.hideOverlay();
    });
  }

  showOverlay() {
    this.element.classList.add("is-active");
    this.element.setAttribute("aria-hidden", "false");
    document.body.classList.add("no-scroll");
    this.element.setAttribute("tabindex", "-1");
    this.element.focus();
  }

  hideOverlay() {
    this.element.classList.remove("is-active");
    this.element.setAttribute("aria-hidden", "true");
    document.body.classList.remove("no-scroll");
    this.element.removeAttribute("tabindex");
  }
}

export default OverlayComponent;
